import React from 'react';

export default function ProfileLimitReached({cancelModal}) {
  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
      <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Profile Limit Reached</p></div> 

<button
             type="button"
             className="close-button"
             onClick={cancelModal}
             aria-label="Close"
           >
             &times;
           </button>
      
        <p>You can create a maximum of 8 additional profiles.</p>
        <div className="send-modal-footer">
        <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Close
                </button>

        </div>
      </div>
    </div>
  );
}